import { Pipe, type PipeTransform } from '@angular/core';
import { CustomerType } from '@shared/zigra-schemas/zigra-schema.autogenerated.models';

@Pipe({
    name: 'zCustomerLegalType'
})
export class CustomerlegalTypePipe implements PipeTransform {
    transform(customer: CustomerType | undefined) {
        switch (customer?.LegalType) {
            case 'INDM':
                return 'Ιδιώτης / Ατομική Επιχείρηση';
            case 'IND':
                return 'Ιδιώτης';
            case 'COR':
                return 'Εταιρία / Οργανισμός';
            case 'GORG':
                return 'Κρατικός Οργανισμός';
            case 'MKO':
                return 'Μ.Κ.Ο';
            case 'OTH':
                return 'Άλλο';
        }

        // <!-- { Code: 'IND', Title: 'Ιδιώτης' },
        // { Code: 'INDM', Title: 'Ιδιώτης / Ατομική Επιχείρηση' },
        // { Code: 'COR', Title: 'Εταιρία / Οργανισμός' },
        // { Code: 'GORG', Title: 'Κρατικός Οργανισμός' },
        // { Code: 'MKO', Title: 'Μ.Κ.Ο' },
        // { Code: 'OTH', Title: 'Άλλο' } -->

        return customer?.LegalType;
    }
}
